import { HStack, Spacer, Text, Button, Link } from "@chakra-ui/react";
import { DownloadDesktopAppIcon } from "modules/icons";
import React, { memo } from "react";
import colors from "app/colors";
import { platform } from "@todesktop/client-core";

const DOWNLOAD_URL = "https://desktop.teamsynco.com";

const DownloadDesktopApp = () => {
  if (platform.todesktop.isDesktopApp()) {
    return null;
  }

  return (
    <HStack h={10} bg={colors.blue20} px={2} py={1}>
      <DownloadDesktopAppIcon fill={colors.blue} />
      <Text fontSize={14} fontWeight={500} color={colors.gray50}>
        Download the Synco desktop app
      </Text>
      <Spacer />
      <Link href={DOWNLOAD_URL} isExternal _hover={{ textDecoration: "none" }}>
        <Button
          size="xs"
          bg={colors.blue}
          fontSize={12}
          fontWeight={700}
          color={colors.white}
          variant="hover"
        >
          Download
        </Button>
      </Link>
    </HStack>
  );
};

export default memo(DownloadDesktopApp);
